import React from 'react';
import PropTypes from 'prop-types';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as organisationsActions from 'app/ducks/organisations/actions';

import * as organisationSelectors from 'app/ducks/organisations/selectors';
import DashboardSimple from './components/DashboardSimple';


function selector(state) {
  return {
    organisations: organisationSelectors.getOrganisations(state),
  };
}

const actionCreators = _.merge(organisationsActions);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class DashboardLayout extends React.Component {
  static propTypes = {
    appReady: PropTypes.bool,
    actions: PropTypes.object,
    organisations: PropTypes.object,
    match: PropTypes.object,
  };

  static defaultProps = {
    appReady: false,
    actions: undefined,
    organisations: undefined,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="dashboard-app" match={this.props.match}>
        <Route
          exact
          path={['/dashboard', '/']}
          render={(): React.ReactNode => (
            <DashboardSimple
              appReady={this.props.appReady}
              match={this.props.match}
              actions={this.props.actions}
              organisations={this.props.organisations}
            />
          )}
        />
      </RenderContent>
    );
  }
}
